import { createActions, createReducer } from 'reduxsauce';

import { setInitial, updateProp } from 'Reducers/shared';

export const { Types, Creators } = createActions(
  {
    checkIn: null,
    checkInError: ['error'],
    checkOut: ['id'],
    checkOutError: ['error'],
    checkOutSuccess: ['checkInId'],
    checkOutSuccessHandler: ['userId', 'checkInId'],
    get: null,
    getAddress: ['payload', 'userId'],
    getCitiesByPostCode: ['data'],
    getCitiesByPostCodeSuccess: ['payload'],
    set: ['payload', 'userId'],
    setAddress: ['payload', 'userId', 'checkInId'],
    updateProp: ['key', 'value'],
    verifyCheckIn: ['flowId'],
    verifyCheckInSuccess: ['payload', 'flowId']
  },
  { prefix: 'checkIn/' }
);

const initialState = {};

const initialCheckInsState = {
  checkIns: []
};

export const set = (state, { payload, userId }) => {
  const newState = setInitial(state, userId, initialCheckInsState);
  newState[userId]['checkIns'] = payload;
  return newState;
};

export const checkOutSuccessHandler = (state, { userId, checkInId }) => {
  const newState = { ...state };

  if (newState[userId]) {
    newState[userId].checkIns = newState[userId]?.checkIns?.filter(checkIn => checkIn.id !== checkInId);
  }

  return newState;
};

export const setAddress = (state, { payload, userId, checkInId }) => {
  let checkIndex;
  for (const [index, c] of state[userId].checkIns.entries()) {
    if (c.id === checkInId) {
      checkIndex = index;
    }
  }

  // store only the first 10,000 addresses to prevent excessive memory usage
  const cappedPayload = Array.isArray(payload) ? payload.slice(0, 10000) : payload;

  state[userId].checkIns[checkIndex].address = cappedPayload;

  return { ...state };
};

export const getCitiesByPostCodeSuccess = (state, { payload, userId, checkInId }) => {
  const checkIns = state[userId]?.checkIns || [];
  const checkIndex = checkIns.findIndex(checkIn => checkIn.id === checkInId);

  if (checkIndex !== -1) {
    checkIns[checkIndex].cities = payload;
  }

  return { ...state };
};

// when a BA is checked in on more than one flow at once (e.g. BE + LU same day), pick the
// check-in matching the flow currently loaded, instead of always defaulting to the first one
const currentCheckIn = state => {
  const checkIns = state.checkIn[state.user.id]?.checkIns || [];
  const currentFlowId = state.flow?.currentFlowIndex;
  return checkIns.find(checkIn => String(checkIn.published_flow?.id) === String(currentFlowId)) || checkIns[0];
};

export const checkInCities = state => currentCheckIn(state)?.cities;
export const checkInCountry = state => currentCheckIn(state)?.country;
export const checkedInPostCodes = state => currentCheckIn(state)?.selected_postcodes;

export default createReducer(initialState, {
  [Types.CHECK_OUT_SUCCESS_HANDLER]: checkOutSuccessHandler,
  [Types.GET_CITIES_BY_POST_CODE_SUCCESS]: getCitiesByPostCodeSuccess,
  [Types.SET_ADDRESS]: setAddress,
  [Types.SET]: set,
  [Types.UPDATE_PROP]: updateProp
});
